import { Color } from '@deck.gl/core';
import { colorLib } from '@larki/mp';
import { DataType } from '@larki/mp/lib/dataType';

export const USER_COLORS = [
  { name: 'Yellow', color: '#FFBB0C' },
  { name: 'Purple', color: '#8E53EE' },
  { name: 'Red', color: '#CC1027' },
  { name: 'Teal', color: '#157DAA' },
  { name: 'Orange', color: '#EC7100' },
  { name: 'Green', color: '#04C28E' },
  { name: 'Pink', color: '#E55384' },
  { name: 'Blue', color: '#203088' },
];

export const DATA_TYPE_COLORS: Record<DataType, string> = {
  unknown: '#9b9b9b',
  streetscape: '#3048c9',
  aerial: '#157daa',
  drone: '#b087f3',
  exterior: '#e55384',
  interior: '#f47601',
  bim_exterior: '#e55384',
  bim_interior: '#f47601',
  twod_plan_exterior: '#e55384',
  twod_plan_interior: '#f47601',
  custom: '#9b9b9b',
  pedestrian: '#b087f3',
  _2d_plan_on_map: '#9b9b9b',
};

const SHAPE_OPACITY = 255 * (40 / 100); // 40%
export const SHAPE_DRAWN_LINE_COLOR = [0, 0, 0, 150] as Color;

export const INACTIVE_LINE_WIDTH_WITH_DATA_TYPE = 1;
export const INACTIVE_LINE_COLOR_WITH_DATA_TYPE = [0, 0, 0, 30] as Color;
export const INACTIVE_FILL_COLOR_WITH_DATA_TYPE = [160, 160, 160, 10] as Color;

export const ACTIVE_LINE_COLOR_WITH_DATA_TYPE = SHAPE_DRAWN_LINE_COLOR;
export const ACTIVE_FILL_COLOR_WITH_DATA_TYPE = [160, 160, 160, 10] as Color;

export const DRAFT_COLOR_RGB: [number, number, number] = [155, 155, 155];
export const DRAFT_FILL_COLOR = [...DRAFT_COLOR_RGB, SHAPE_OPACITY] as Color;
export const DRAFT_LINE_COLOR = [...DRAFT_COLOR_RGB, 255] as Color;

// TODO: This is not for free map only, but for all maps
export const FREE_MAP_DRAFT_PALETTE: [number, number, number][] = [
  [0, 255, 100], // bright green
  [0, 200, 200], // cyan/teal
  [80, 50, 120], // dark purple
  [180, 90, 60], // reddish-brown
  [180, 120, 220], // medium purple
  [120, 140, 180], // muted blue
  [100, 180, 255], // bright sky blue
  [0, 100, 60], // dark green
];

export function shapeFillColor(rgb: [number, number, number]): Color {
  return [...rgb, SHAPE_OPACITY] as Color;
}

export function shapeLineColor(rgb: [number, number, number]): Color {
  return [...rgb, 255] as Color;
}

const DATA_TYPE_RGB: Record<DataType, [number, number, number]> =
  Object.fromEntries(
    (Object.entries(DATA_TYPE_COLORS) as [DataType, string][]).map(
      ([dataType, hex]) => [dataType, colorLib.hexToRgb(hex)]
    )
  ) as Record<DataType, [number, number, number]>;

export function resolveShapeColor(shape: {
  color?: [number, number, number];
  dataType: DataType;
}): [number, number, number] {
  if (shape.color) return shape.color;
  return DATA_TYPE_RGB[shape.dataType] ?? DATA_TYPE_RGB.unknown;
}
